import React from "react";

const DoubleCheck = ({ viewBox = "0 0 20 20", className = "hayley-h-6 hayley-w-6 hayley-text-inherit" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox={viewBox} className={className}>
      <path stroke="currentColor" strokeLinecap="square" strokeMiterlimit="10" d="M2.083 11.25l3.333 3.333 8.334-10M9.583 13.75l.833.833 8.334-10"></path>
    </svg>
  );
};

export default DoubleCheck;
